import { api } from './base-api';
import {
  ClienteProdutoDetail,
  ClienteProdutosFilters,
  PaginatedClienteProdutos,
} from '../../types/cliente-produto';

const cleanParams = (filters: Record<string, unknown>) => {
  const result: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null || value === '') continue;
    result[key] = value as string | number | boolean;
  }
  return result;
};

export interface ListClienteProdutosParams extends Partial<ClienteProdutosFilters> {
  page?: number;
  limit?: number;
}

export const clienteProdutosApi = {
  async listByCliente(
    clienteId: string,
    params: ListClienteProdutosParams = {},
  ): Promise<PaginatedClienteProdutos> {
    const { data } = await api.get<PaginatedClienteProdutos>(
      `/admin/clientes/${clienteId}/produtos`,
      { params: cleanParams({ ...(params as Record<string, unknown>) }) },
    );
    return data;
  },

  async detail(produtoId: string): Promise<ClienteProdutoDetail> {
    const { data } = await api.get<ClienteProdutoDetail>(
      `/admin/produtos/${produtoId}`,
    );
    return data;
  },
};
